import { chartColors } from '../../common/colors'

export const EMPTY_SLICE_TYPE = 'empty-arc'

class SunburstService {
  formatDataForDisplay (data, colors, maxDepth) {
    formatDataForDisplayRecursively(data, colors, maxDepth, 1, undefined)
  }

  getTypeColors (types) {
    const typeList = Object.keys(types)
    return typeList.reduce((result, type, index) => {
      result[type] = chartColors[index]
      return result
    }, {})
  }

  getSunburstDataByLayer (data, targetIndex) {
    return getSunburstDataByLayerRecursively(data, targetIndex, 1)
  }

  getSunburstDepth (data) {
    const depths = []

    data.forEach((datum) => {
      if (datum.children) {
        depths.push(1 + this.getSunburstDepth(datum.children))
      } else {
        depths.push(1)
      }
    })

    return Math.max(...depths)
  }

  selectSunburstPath (data) {
    data.selected = true
    if (data.parent) {
      this.selectSunburstPath(data.parent)
    }
  }

  clearSelection (data) {
    data.forEach((datum) => {
      datum.selected = false
      if (datum.children) {
        this.clearSelection(datum.children)
      }
    })
  }

  getSunburstPath (data) {
    let path = [data]

    if (data.parent) {
      const parentPath = this.getSunburstPath(data.parent)
      path = parentPath.concat(path)
    }

    return path
  }
}

function formatDataForDisplayRecursively (data, colors, maxDepth, currentLayerIndex, parentSlice) {
  const total = data.reduce((result, pieSlice) => (result + pieSlice.value), 0)

  if (parentSlice && parentSlice.value !== total) {
    data.push({ 'type': EMPTY_SLICE_TYPE, 'value': parentSlice.value - total, 'parent': parentSlice })
  }

  data.forEach((pieSlice) => {
    pieSlice.color = colors[pieSlice.type]

    if (parentSlice) {
      pieSlice.parent = parentSlice
    }

    if (!pieSlice.children && (currentLayerIndex < maxDepth)) {
      pieSlice.children = [
        { 'type': EMPTY_SLICE_TYPE, 'value': pieSlice.value, 'parent': parentSlice }
      ]
    }

    if (pieSlice.children) {
      formatDataForDisplayRecursively(pieSlice.children, colors, maxDepth, currentLayerIndex + 1, pieSlice)
    }
  })
}

function getSunburstDataByLayerRecursively (data, targetIndex, currentLayerIndex) {
  let result = []

  if (currentLayerIndex === targetIndex) {
    result = result.concat(data)
  } else {
    data.forEach((pieSlice) => {
      if (pieSlice.children) {
        const resultForNextLayer = getSunburstDataByLayerRecursively(pieSlice.children, targetIndex, currentLayerIndex + 1)
        result = result.concat(resultForNextLayer)
      }
    })
  }

  return result
}

export const sunburstService = new SunburstService()
